/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   vssf\client\webapi\httpclients\clientgeneratorconfigs\organization.genclient.json
 */

"use strict";

import Contracts = require("VSS/Organization/Contracts");
import VSS_Common_Contracts = require("VSS/WebApi/Contracts");
import VSS_Service = require("VSS/Service");
import VSS_WebApi = require("VSS/WebApi/RestClient");
import VSS_WebApi_Constants = require("VSS/WebApi/Constants");

export class CommonMethods3To7_2 extends VSS_WebApi.VssHttpClient {

    public static serviceInstanceId = VSS_WebApi_Constants.ServiceInstanceTypes.SPS;
    protected collectionPropertiesApiVersion: string;
    protected collectionsApiVersion: string;
    protected organizationLogoApiVersion: string;
    protected organizationMigrationBlobsApiVersion: string;
    protected organizationPropertiesApiVersion: string;
    protected organizationsApiVersion: string;
    protected regionsApiVersion: string;

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
    }

    /**
     * [Preview API]
     *
     * @param {boolean} includeRegionsWithNoAvailableHosts
     * @return IPromise<Contracts.Region[]>
     */
    public getRegions(
        includeRegionsWithNoAvailableHosts?: boolean
        ): IPromise<Contracts.Region[]> {

        const queryValues: any = {
            includeRegionsWithNoAvailableHosts: includeRegionsWithNoAvailableHosts
        };

        return this._beginRequest<Contracts.Region[]>({
            httpMethod: "GET",
            area: "Organization",
            locationId: "6f84936f-1801-46f6-94fa-1817545d366d",
            resource: "Regions",
            routeTemplate: "_apis/{area}/{resource}",
            responseType: Contracts.TypeInfo.Region,
            responseIsCollection: true,
            queryParams: queryValues,
            apiVersion: this.regionsApiVersion
        });
    }

    /**
     * [Preview API]
     *
     * @param {VSS_Common_Contracts.JsonPatchDocument} patchDocument
     * @param {string} organizationId
     * @return IPromise<Contracts.Organization>
     */
    public updateOrganization(
        patchDocument: VSS_Common_Contracts.JsonPatchDocument,
        organizationId: string
        ): IPromise<Contracts.Organization> {

        return this._beginRequest<Contracts.Organization>({
            httpMethod: "PATCH",
            area: "Organization",
            locationId: "95f49097-6cdc-4afe-a039-48b4d4c4cbf7",
            resource: "Organizations",
            routeTemplate: "_apis/{area}/{resource}/{organizationId}",
            responseType: Contracts.TypeInfo.Organization,
            routeValues: {
                organizationId: organizationId
            },
            customHeaders: {
                "Content-Type": "application/json-patch+json",
            },
            apiVersion: this.organizationsApiVersion,
            data: patchDocument
        });
    }

    /**
     * [Preview API]
     *
     * @param {Contracts.OrganizationSearchKind} searchKind
     * @param {string} searchValue
     * @param {boolean} isActivated
     * @return IPromise<Contracts.Organization[]>
     */
    public getOrganizations(
        searchKind: Contracts.OrganizationSearchKind,
        searchValue: string,
        isActivated?: boolean
        ): IPromise<Contracts.Organization[]> {

        const queryValues: any = {
            searchKind: searchKind,
            searchValue: searchValue,
            isActivated: isActivated
        };

        return this._beginRequest<Contracts.Organization[]>({
            httpMethod: "GET",
            area: "Organization",
            locationId: "95f49097-6cdc-4afe-a039-48b4d4c4cbf7",
            resource: "Organizations",
            routeTemplate: "_apis/{area}/{resource}/{organizationId}",
            responseType: Contracts.TypeInfo.Organization,
            responseIsCollection: true,
            queryParams: queryValues,
            apiVersion: this.organizationsApiVersion
        });
    }

    /**
     * [Preview API]
     *
     * @param {string} organizationId
     * @param {string[]} propertyNames
     * @return IPromise<Contracts.Organization>
     */
    public getOrganization(
        organizationId: string,
        propertyNames?: string[]
        ): IPromise<Contracts.Organization> {

        const queryValues: any = {
            propertyNames: propertyNames && propertyNames.join(",")
        };

        return this._beginRequest<Contracts.Organization>({
            httpMethod: "GET",
            area: "Organization",
            locationId: "95f49097-6cdc-4afe-a039-48b4d4c4cbf7",
            resource: "Organizations",
            routeTemplate: "_apis/{area}/{resource}/{organizationId}",
            responseType: Contracts.TypeInfo.Organization,
            routeValues: {
                organizationId: organizationId
            },
            queryParams: queryValues,
            apiVersion: this.organizationsApiVersion
        });
    }

    /**
     * [Preview API]
     *
     * @param {string} tenantId
     * @return IPromise<Contracts.Organization>
     */
    public getOldestOrganizationByTenant(
        tenantId: string
        ): IPromise<Contracts.Organization> {

        const queryValues: any = {
            tenantId: tenantId
        };

        return this._beginRequest<Contracts.Organization>({
            httpMethod: "GET",
            area: "Organization",
            locationId: "95f49097-6cdc-4afe-a039-48b4d4c4cbf7",
            resource: "Organizations",
            routeTemplate: "_apis/{area}/{resource}/{organizationId}",
            responseType: Contracts.TypeInfo.Organization,
            queryParams: queryValues,
            apiVersion: this.organizationsApiVersion
        });
    }

    /**
     * [Preview API]
     *
     * @param {Contracts.Organization} resource
     * @return IPromise<Contracts.Organization>
     */
    public createOrganization(
        resource: Contracts.Organization
        ): IPromise<Contracts.Organization> {

        return this._beginRequest<Contracts.Organization>({
            httpMethod: "POST",
            area: "Organization",
            locationId: "95f49097-6cdc-4afe-a039-48b4d4c4cbf7",
            resource: "Organizations",
            routeTemplate: "_apis/{area}/{resource}/{organizationId}",
            requestType: Contracts.TypeInfo.Organization,
            responseType: Contracts.TypeInfo.Organization,
            apiVersion: this.organizationsApiVersion,
            data: resource
        });
    }

    /**
     * [Preview API]
     *
     * @param {string} organizationId
     * @param {VSS_Common_Contracts.JsonPatchDocument} patchDocument
     * @return IPromise<boolean>
     */
    public updateOrganizationProperties(
        organizationId: string,
        patchDocument: VSS_Common_Contracts.JsonPatchDocument
        ): IPromise<boolean> {

        return this._beginRequest<boolean>({
            httpMethod: "PATCH",
            area: "Organization",
            locationId: "103707c6-236d-4434-a0a2-9031fbb65fa6",
            resource: "OrganizationProperties",
            routeTemplate: "_apis/{area}/Organizations/{organizationId}/Properties",
            routeValues: {
                organizationId: organizationId
            },
            customHeaders: {
                "Content-Type": "application/json-patch+json",
            },
            apiVersion: this.organizationPropertiesApiVersion,
            data: patchDocument
        });
    }

    /**
     * [Preview API]
     *
     * @param {Contracts.OrganizationMigrationBlob} migrationBlob
     * @return IPromise<void>
     */
    public importOrganizationMigrationBlob(
        migrationBlob: Contracts.OrganizationMigrationBlob
        ): IPromise<void> {

        return this._beginRequest<void>({
            httpMethod: "POST",
            httpResponseType: "html",
            area: "Organization",
            locationId: "93f69239-28ba-497e-b4d4-33e51e6303c3",
            resource: "OrganizationMigrationBlobs",
            routeTemplate: "_apis/{area}/{resource}/{organizationId}",
            apiVersion: this.organizationMigrationBlobsApiVersion,
            data: migrationBlob
        });
    }

    /**
     * [Preview API]
     *
     * @param {string} organizationId
     * @return IPromise<Contracts.OrganizationMigrationBlob>
     */
    public exportOrganizationMigrationBlob(
        organizationId: string
        ): IPromise<Contracts.OrganizationMigrationBlob> {

        return this._beginRequest<Contracts.OrganizationMigrationBlob>({
            httpMethod: "GET",
            area: "Organization",
            locationId: "93f69239-28ba-497e-b4d4-33e51e6303c3",
            resource: "OrganizationMigrationBlobs",
            routeTemplate: "_apis/{area}/{resource}/{organizationId}",
            routeValues: {
                organizationId: organizationId
            },
            apiVersion: this.organizationMigrationBlobsApiVersion
        });
    }

    /**
     * [Preview API]
     *
     * @param {string} organizationId
     * @param {Contracts.Logo} logo
     * @return IPromise<boolean>
     */
    public updateOrganizationLogo(
        organizationId: string,
        logo: Contracts.Logo
        ): IPromise<boolean> {

        return this._beginRequest<boolean>({
            httpMethod: "POST",
            area: "Organization",
            locationId: "a9eeec19-85b4-40ae-8a52-b4f697260ac4",
            resource: "OrganizationLogo",
            routeTemplate: "_apis/{area}/Organizations/{organizationId}/Logo",
            routeValues: {
                organizationId: organizationId
            },
            apiVersion: this.organizationLogoApiVersion,
            data: logo
        });
    }

    /**
     * [Preview API]
     *
     * @param {VSS_Common_Contracts.JsonPatchDocument} patchDocument
     * @param {string} collectionId
     * @return IPromise<Contracts.Collection>
     */
    public updateCollection(
        patchDocument: VSS_Common_Contracts.JsonPatchDocument,
        collectionId: string
        ): IPromise<Contracts.Collection> {

        return this._beginRequest<Contracts.Collection>({
            httpMethod: "PATCH",
            area: "Organization",
            locationId: "668b5607-0db2-49bb-83f8-5f46f1094250",
            resource: "Collections",
            routeTemplate: "_apis/{area}/{resource}/{collectionId}",
            responseType: Contracts.TypeInfo.Collection,
            routeValues: {
                collectionId: collectionId
            },
            customHeaders: {
                "Content-Type": "application/json-patch+json",
            },
            apiVersion: this.collectionsApiVersion,
            data: patchDocument
        });
    }

    /**
     * [Preview API]
     *
     * @param {string} collectionId
     * @param {string} collectionName
     * @return IPromise<boolean>
     */
    public restoreCollection(
        collectionId: string,
        collectionName: string
        ): IPromise<boolean> {

        const queryValues: any = {
            collectionName: collectionName
        };

        return this._beginRequest<boolean>({
            httpMethod: "PATCH",
            area: "Organization",
            locationId: "668b5607-0db2-49bb-83f8-5f46f1094250",
            resource: "Collections",
            routeTemplate: "_apis/{area}/{resource}/{collectionId}",
            routeValues: {
                collectionId: collectionId
            },
            queryParams: queryValues,
            apiVersion: this.collectionsApiVersion
        });
    }

    /**
     * [Preview API]
     *
     * @param {string} collectionId
     * @return IPromise<boolean>
     */
    public isEligibleForTakeOver(
        collectionId: string
        ): IPromise<boolean> {

        return this._beginRequest<boolean>({
            httpMethod: "POST",
            area: "Organization",
            locationId: "668b5607-0db2-49bb-83f8-5f46f1094250",
            resource: "Collections",
            routeTemplate: "_apis/{area}/{resource}/{collectionId}",
            routeValues: {
                collectionId: collectionId
            },
            apiVersion: this.collectionsApiVersion
        });
    }

    /**
     * [Preview API]
     *
     * @param {Contracts.CollectionSearchKind} searchKind
     * @param {string} searchValue
     * @param {boolean} includeDeletedCollections
     * @return IPromise<Contracts.Collection[]>
     */
    public getCollections(
        searchKind?: Contracts.CollectionSearchKind,
        searchValue?: string,
        includeDeletedCollections?: boolean
        ): IPromise<Contracts.Collection[]> {

        const queryValues: any = {
            searchKind: searchKind,
            searchValue: searchValue,
            includeDeletedCollections: includeDeletedCollections
        };

        return this._beginRequest<Contracts.Collection[]>({
            httpMethod: "GET",
            area: "Organization",
            locationId: "668b5607-0db2-49bb-83f8-5f46f1094250",
            resource: "Collections",
            routeTemplate: "_apis/{area}/{resource}/{collectionId}",
            responseType: Contracts.TypeInfo.Collection,
            responseIsCollection: true,
            queryParams: queryValues,
            apiVersion: this.collectionsApiVersion
        });
    }

    /**
     * [Preview API]
     *
     * @param {string} collectionId
     * @param {string[]} propertyNames
     * @return IPromise<Contracts.Collection>
     */
    public getCollection(
        collectionId: string,
        propertyNames?: string[]
        ): IPromise<Contracts.Collection> {

        const queryValues: any = {
            propertyNames: propertyNames && propertyNames.join(",")
        };

        return this._beginRequest<Contracts.Collection>({
            httpMethod: "GET",
            area: "Organization",
            locationId: "668b5607-0db2-49bb-83f8-5f46f1094250",
            resource: "Collections",
            routeTemplate: "_apis/{area}/{resource}/{collectionId}",
            responseType: Contracts.TypeInfo.Collection,
            routeValues: {
                collectionId: collectionId
            },
            queryParams: queryValues,
            apiVersion: this.collectionsApiVersion
        });
    }

    /**
     * [Preview API]
     *
     * @param {string} forceUpdateReason
     * @param {string} collectionId
     * @param {string} newOwner
     * @return IPromise<Contracts.Collection>
     */
    public forceUpdateCollectionOwner(
        forceUpdateReason: string,
        collectionId: string,
        newOwner: string
        ): IPromise<Contracts.Collection> {

        const queryValues: any = {
            newOwner: newOwner
        };

        return this._beginRequest<Contracts.Collection>({
            httpMethod: "POST",
            area: "Organization",
            locationId: "668b5607-0db2-49bb-83f8-5f46f1094250",
            resource: "Collections",
            routeTemplate: "_apis/{area}/{resource}/{collectionId}",
            responseType: Contracts.TypeInfo.Collection,
            routeValues: {
                collectionId: collectionId
            },
            queryParams: queryValues,
            apiVersion: this.collectionsApiVersion,
            data: forceUpdateReason
        });
    }

    /**
     * [Preview API]
     *
     * @param {string} collectionId
     * @param {number} gracePeriodToRestoreInHours
     * @param {boolean} violatedTerms
     * @return IPromise<boolean>
     */
    public deleteCollection(
        collectionId: string,
        gracePeriodToRestoreInHours?: number,
        violatedTerms?: boolean
        ): IPromise<boolean> {

        const queryValues: any = {
            gracePeriodToRestoreInHours: gracePeriodToRestoreInHours,
            violatedTerms: violatedTerms
        };

        return this._beginRequest<boolean>({
            httpMethod: "DELETE",
            area: "Organization",
            locationId: "668b5607-0db2-49bb-83f8-5f46f1094250",
            resource: "Collections",
            routeTemplate: "_apis/{area}/{resource}/{collectionId}",
            routeValues: {
                collectionId: collectionId
            },
            queryParams: queryValues,
            apiVersion: this.collectionsApiVersion
        });
    }

    /**
     * [Preview API]
     *
     * @param {Contracts.Collection} resource
     * @return IPromise<Contracts.Collection>
     */
    public createCollection(
        resource: Contracts.Collection
        ): IPromise<Contracts.Collection> {

        return this._beginRequest<Contracts.Collection>({
            httpMethod: "POST",
            area: "Organization",
            locationId: "668b5607-0db2-49bb-83f8-5f46f1094250",
            resource: "Collections",
            routeTemplate: "_apis/{area}/{resource}/{collectionId}",
            requestType: Contracts.TypeInfo.Collection,
            responseType: Contracts.TypeInfo.Collection,
            apiVersion: this.collectionsApiVersion,
            data: resource
        });
    }

    /**
     * [Preview API]
     *
     * @param {string} collectionId
     * @param {string} geographyName
     * @return IPromise<Contracts.Collection>
     */
    public backfillPreferredGeography(
        collectionId: string,
        geographyName: string
        ): IPromise<Contracts.Collection> {

        const queryValues: any = {
            geographyName: geographyName
        };

        return this._beginRequest<Contracts.Collection>({
            httpMethod: "PUT",
            area: "Organization",
            locationId: "668b5607-0db2-49bb-83f8-5f46f1094250",
            resource: "Collections",
            routeTemplate: "_apis/{area}/{resource}/{collectionId}",
            responseType: Contracts.TypeInfo.Collection,
            routeValues: {
                collectionId: collectionId
            },
            queryParams: queryValues,
            apiVersion: this.collectionsApiVersion
        });
    }

    /**
     * [Preview API]
     *
     * @param {string} collectionId
     * @param {VSS_Common_Contracts.JsonPatchDocument} patchDocument
     * @return IPromise<boolean>
     */
    public updateCollectionProperties(
        collectionId: string,
        patchDocument: VSS_Common_Contracts.JsonPatchDocument
        ): IPromise<boolean> {

        return this._beginRequest<boolean>({
            httpMethod: "PATCH",
            area: "Organization",
            locationId: "a0f9c508-a3c4-456b-a812-3fb0c4743521",
            resource: "CollectionProperties",
            routeTemplate: "_apis/{area}/Collections/{collectionId}/Properties",
            routeValues: {
                collectionId: collectionId
            },
            customHeaders: {
                "Content-Type": "application/json-patch+json",
            },
            apiVersion: this.collectionPropertiesApiVersion,
            data: patchDocument
        });
    }
}

export class CommonMethods7_1To7_2 extends CommonMethods3To7_2 {
    protected collectionAvatarApiVersion: string;
    protected geographiesApiVersion: string;

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
    }

    /**
     * [Preview API] Retrieves a set of all geographies available in Azure DevOps.
     *
     * @return IPromise<Contracts.Geography[]>
     */
    public getGeographies(): IPromise<Contracts.Geography[]> {

        return this._beginRequest<Contracts.Geography[]>({
            httpMethod: "GET",
            area: "Organization",
            locationId: "cb720f78-c6e5-4c09-acff-4ed2ef748f72",
            resource: "Geographies",
            routeTemplate: "_apis/{area}/{resource}",
            responseIsCollection: true,
            apiVersion: this.geographiesApiVersion
        });
    }

    /**
     * [Preview API] Update project collection avatar
     *
     * @param {string} collectionId - Id of the project collection
     * @param {number[]} imageData
     * @return IPromise<void>
     */
    public updateCollectionAvatar(
        collectionId: string,
        imageData: number[]
        ): IPromise<void> {

        return this._beginRequest<void>({
            httpMethod: "PUT",
            httpResponseType: "html",
            area: "Organization",
            locationId: "c8dee5f9-f31f-4b10-918c-01ab73892f64",
            resource: "CollectionAvatar",
            routeTemplate: "_apis/{area}/Collections/{collectionId}/Avatar",
            routeValues: {
                collectionId: collectionId
            },
            apiVersion: this.collectionAvatarApiVersion,
            data: imageData
        });
    }

    /**
     * [Preview API] Delete project collection avatar
     *
     * @param {string} collectionId - Id of the project collection
     * @return IPromise<void>
     */
    public deleteCollectionAvatar(
        collectionId: string
        ): IPromise<void> {

        return this._beginRequest<void>({
            httpMethod: "DELETE",
            httpResponseType: "html",
            area: "Organization",
            locationId: "c8dee5f9-f31f-4b10-918c-01ab73892f64",
            resource: "CollectionAvatar",
            routeTemplate: "_apis/{area}/Collections/{collectionId}/Avatar",
            routeValues: {
                collectionId: collectionId
            },
            apiVersion: this.collectionAvatarApiVersion
        });
    }
}

/**
 * @exemptedapi
 */
export class OrganizationHttpClient7_2 extends CommonMethods7_1To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.collectionAvatarApiVersion =
        this.collectionPropertiesApiVersion =
        this.collectionsApiVersion =
        this.geographiesApiVersion =
        this.organizationLogoApiVersion =
        this.organizationMigrationBlobsApiVersion =
        this.organizationPropertiesApiVersion =
        this.organizationsApiVersion =
        this.regionsApiVersion = "7.2-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class OrganizationHttpClient7_1 extends CommonMethods7_1To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.collectionAvatarApiVersion =
        this.collectionPropertiesApiVersion =
        this.collectionsApiVersion =
        this.geographiesApiVersion =
        this.organizationLogoApiVersion =
        this.organizationMigrationBlobsApiVersion =
        this.organizationPropertiesApiVersion =
        this.organizationsApiVersion =
        this.regionsApiVersion = "7.1-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class OrganizationHttpClient7 extends CommonMethods3To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.collectionPropertiesApiVersion =
        this.collectionsApiVersion =
        this.organizationLogoApiVersion =
        this.organizationMigrationBlobsApiVersion =
        this.organizationPropertiesApiVersion =
        this.organizationsApiVersion =
        this.regionsApiVersion = "7.0-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class OrganizationHttpClient6_1 extends CommonMethods3To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.collectionPropertiesApiVersion =
        this.collectionsApiVersion =
        this.organizationLogoApiVersion =
        this.organizationMigrationBlobsApiVersion =
        this.organizationPropertiesApiVersion =
        this.organizationsApiVersion =
        this.regionsApiVersion = "6.1-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class OrganizationHttpClient6 extends CommonMethods3To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.collectionPropertiesApiVersion =
        this.collectionsApiVersion =
        this.organizationLogoApiVersion =
        this.organizationMigrationBlobsApiVersion =
        this.organizationPropertiesApiVersion =
        this.organizationsApiVersion =
        this.regionsApiVersion = "6.0-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class OrganizationHttpClient5_2 extends CommonMethods3To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.collectionPropertiesApiVersion =
        this.collectionsApiVersion =
        this.organizationLogoApiVersion =
        this.organizationMigrationBlobsApiVersion =
        this.organizationPropertiesApiVersion =
        this.organizationsApiVersion =
        this.regionsApiVersion = "5.2-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class OrganizationHttpClient5_1 extends CommonMethods3To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.collectionPropertiesApiVersion =
        this.collectionsApiVersion =
        this.organizationLogoApiVersion =
        this.organizationMigrationBlobsApiVersion =
        this.organizationPropertiesApiVersion =
        this.organizationsApiVersion =
        this.regionsApiVersion = "5.1-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class OrganizationHttpClient5 extends CommonMethods3To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.collectionPropertiesApiVersion =
        this.collectionsApiVersion =
        this.organizationLogoApiVersion =
        this.organizationMigrationBlobsApiVersion =
        this.organizationPropertiesApiVersion =
        this.organizationsApiVersion =
        this.regionsApiVersion = "5.0-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class OrganizationHttpClient4_1 extends CommonMethods3To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.collectionPropertiesApiVersion =
        this.collectionsApiVersion =
        this.organizationLogoApiVersion =
        this.organizationMigrationBlobsApiVersion =
        this.organizationPropertiesApiVersion =
        this.organizationsApiVersion =
        this.regionsApiVersion = "4.1-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class OrganizationHttpClient4 extends CommonMethods3To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.collectionPropertiesApiVersion =
        this.collectionsApiVersion =
        this.organizationLogoApiVersion =
        this.organizationMigrationBlobsApiVersion =
        this.organizationPropertiesApiVersion =
        this.organizationsApiVersion =
        this.regionsApiVersion = "4.0-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class OrganizationHttpClient3_2 extends CommonMethods3To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.collectionPropertiesApiVersion =
        this.collectionsApiVersion =
        this.organizationLogoApiVersion =
        this.organizationMigrationBlobsApiVersion =
        this.organizationPropertiesApiVersion =
        this.organizationsApiVersion =
        this.regionsApiVersion = "3.2-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class OrganizationHttpClient3_1 extends CommonMethods3To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.collectionPropertiesApiVersion =
        this.collectionsApiVersion =
        this.organizationLogoApiVersion =
        this.organizationMigrationBlobsApiVersion =
        this.organizationPropertiesApiVersion =
        this.organizationsApiVersion =
        this.regionsApiVersion = "3.1-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class OrganizationHttpClient3 extends CommonMethods3To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.collectionPropertiesApiVersion =
        this.collectionsApiVersion =
        this.organizationLogoApiVersion =
        this.organizationMigrationBlobsApiVersion =
        this.organizationPropertiesApiVersion =
        this.organizationsApiVersion =
        this.regionsApiVersion = "3.0-preview.1";
    }
}

export class OrganizationHttpClient extends OrganizationHttpClient7_2 {
    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
    }
}

const clientMapping: { [id: string]: new (routeRequestPath: string) => VSS_WebApi.VssHttpClient; } = {
    "7.2": OrganizationHttpClient7_2,
    "7.1": OrganizationHttpClient7_1,
    "7.0": OrganizationHttpClient7,
    "6.1": OrganizationHttpClient6_1,
    "6.0": OrganizationHttpClient6,
    "5.2": OrganizationHttpClient5_2,
    "5.1": OrganizationHttpClient5_1,
    "5.0": OrganizationHttpClient5,
    "4.1": OrganizationHttpClient4_1,
    "4.0": OrganizationHttpClient4,
    "3.2": OrganizationHttpClient3_2,
    "3.1": OrganizationHttpClient3_1,
    "3.0": OrganizationHttpClient3
}

/**
 * Gets an http client targeting the latest released version of the APIs.
 *
 * @return OrganizationHttpClient7_1
 */
export function getClient(options?: VSS_WebApi.IVssHttpClientOptions): OrganizationHttpClient7_1 {
    if ((<any>window).VSS && (<any>window).VSS.VssSDKRestVersion && clientMapping[(<any>window).VSS.VssSDKRestVersion]) {
        return VSS_Service.getClient<OrganizationHttpClient7_1>(<any>(clientMapping[(<any>window).VSS.VssSDKRestVersion]), undefined, undefined, undefined, options);
    }
    else {
        return VSS_Service.getClient<OrganizationHttpClient7_1>(OrganizationHttpClient7_1, undefined, undefined, undefined, options);
    }
}
